export const css = {
	root: 'ExNkIeVi',
	' _key': 'apic-theme/apic/table-of-contents/trigger'
};

export default css;
